import { useQuery } from "@tanstack/react-query"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"
import { useApiContext } from "@/hooks/api/use-api-context"
import { useDevAuth } from "@/hooks/use-dev-auth"

export interface IdentityCompany {
  id: string
  name: string
  logo_url: string | null
  dark_mode_logo_url: string | null
  clerk_organization_id: string | null
  organization: { id: string; name: string } | null
}

interface IdentityCompaniesResponse {
  companies: IdentityCompany[]
}

function fetchIdentityCompanies(context: ApiContext) {
  return apiContextFetch<IdentityCompaniesResponse>(context, "identity_companies")
}

export function useFetchIdentityCompanies() {
  const getContext = useApiContext()
  const { isLoaded, isSignedIn, userId } = useDevAuth()

  return useQuery({
    queryKey: ["identity-companies", userId],
    queryFn: async () => {
      const context = await getContext()
      return fetchIdentityCompanies(context)
    },
    enabled: isLoaded && isSignedIn,
    staleTime: 5 * 60 * 1000,
  })
}
